<div class="home-content" *ngIf="isServerAvailable">
  <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" nzAlign="top" class="grid-row" nzJustify="start">
    <div nz-col [nzSpan]="12" class="pageTitle" >
      home
    </div>
  </div>
  <div class="alert alert-secondary" role="alert">    
    <p>The purpose of the Partner Query Tool is to have all queries and requests for clarification/additional
      information, from Partners, centralized in a single tool where Partners can submit queries to the Operator, track
      the query and receive responses in a timely manner.</p>
  </div>
  <div class="row" *ngIf="currentUser.IsRFCAdmin || currentUser.Is_Partner">
    <div class="col-sm-6">
      <div class="card text-center" style="border: 1px solid #dbdcdd;">
        <div class="card-body">
          <h5 class="card-title">Submit a new query</h5>
          <p class="card-text">This refers to a section where users can create and submit a new query. 
            It allows users to provide details and send their query to the appropriate team for review and response.</p>
          <a href="#" class="btn btn-primary mx-auto" [routerLink]="'/clarification-query/create-query'">Create Query</a>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="card text-center" style="border: 1px solid #dbdcdd;">
        <div class="card-body">
          <h5 class="card-title">View all your queries</h5>
          <p class="card-text">This refers to a section where users can view all their submitted queries. It helps track query status, review responses, and manage requests effectively.</p>
          <a href="#" class="btn btn-primary mx-auto" [routerLink]="'/clarification-query/all_query_request'">View Queries</a>
        </div>
      </div>
    </div>
  </div>  
</div>
<main *ngIf="!isServerAvailable" class="container" style="display: flex; justify-content: center; align-items: center; text-align: center; height: 100px;">
  <nz-result nzStatus="500" nzTitle="We are facing technical issue while faching data from backend. Please try after some time or contact site administrator.">
    
    </nz-result>
</main>